<template>
  <div class="flex flex-wrap pt-2" v-if="config.videos.length > 0">
    <template v-for="_video in config.videos" :key="_video.dvv_id">
      <template v-if="
        (
          dockList &&
          _video.cameradock &&
          !_video.isWebcam
        )
        ||
        (
          dockList &&
          _video.cameradock &&
          _video.isWebcam &&
          config.webcam.online
        )
        ||
        (
          !dockList &&
          !_video.cameradock
        )
      ">
        <!-- |||||||||||||||||||||| -->

        <div
          class="text-xs bg-g2 hover:!bg-flyingeye-light h-full flex items-center justify-center cursor-pointer px-[8px] py-[1px] mr-2 mb-1"
          :class="{
            'bg-success font-medium': _video.publish,
            '!bg-flyingeye': _video.open,
          }"
          @click="toggleVideo(_video)"
        >

          <!-- |||||||||||||||||||||| -->

          {{ _video.dvv_text }}
          <span class="font-mono" v-if="_video.read != 0">
             ({{ _video.read }})
          </span>

          <!-- |||||||||||||||||||||| -->

        </div>

        <!-- |||||||||||||||||||||| -->

      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "Videos_List",
  components: {
  },

  props: {
    config: {
      type: Object,
    },
    dockList: {
      type: Boolean,
      default: false
    },

  },

  setup() {
    return {
    };
  },

  async mounted() {
  },


  methods: {
    toggleVideo(video) {
      this.config.methods.ToggleVideo(this.config, video);
    },
  },

  watch: {
    'config.webcam.online': {
      handler(newVal, oldVal) {
        if (newVal == oldVal) return;
        this.$forceUpdate();
      },
      deep: true,
    },
  },
};
</script>
